import type { JSX } from 'react';

import { ProposeWager } from '../components/ProposeWager.tsx';
import { WagerList } from '../components/WagerList.tsx';

/** Head-to-head bets: offering one, and answering the ones offered to you. */
export function Wagers(): JSX.Element {
  return (
    <>
      <ProposeWager />
      <WagerList />
    </>
  );
}
